export const color = {
  darkBlue: '#394c73',
  blue: '#4977e1',
  // lightBlue: '#d3dae9',
  darkRed: '#b93429',
  lightGray: '#ebeef8', // #eaeff9 // #ebeef8
  gray: '#d3dae9',
  darkGray: '#828997'
};

export const colorMono = {
  white: '#fdfdfd',
  black: '#000000'
};

export const mainColors = {
  primary: color.darkBlue,
  primaryDark: color.darkBlue,
  secondary: color.darkRed,
  secondaryDark: colorMono.white,
  trinary: color.blue
};

export const colorGray = {
  primary: colorMono.black,
  secondary: color.darkGray,
  colored: mainColors.primary
};

export const colorText = {
  primary: colorMono.black,
  secondary: color.darkGray,
  colored: mainColors.primary
};

export const colors = {
  color,
  mainColors,
  colorText,
  colorMono,
  colorGray
};
